import { AnalyticsEvent } from 'utils/analytics'
import { Path } from 'constants/router'
import { isImageUploadProduct } from 'utils/product'
import { useEffect } from 'react'
import { useGallery } from '../contexts/Gallery.context'
import { useGalleryAssignment } from '../contexts/GalleryAssignment.context'
import { useGalleryConstants } from '../contexts/GalleryConstants.context'
import { useNavigate } from 'react-router-dom'

/** Image products are delivered through the upload page; the gallery only reaches them via stale links, so hand off while uploads are still open. */
export const useCreativeGalleryUploadRedirect = (): boolean => {
  const navigate = useNavigate()
  const { assignmentId } = useGallery()
  const { product, assignmentStage, logGalleryEvent } = useGalleryAssignment()
  const { stagesUnlockingCreativeManipulateVisuals } = useGalleryConstants()

  const shouldRedirect = !!product && !!assignmentStage && isImageUploadProduct(product) && stagesUnlockingCreativeManipulateVisuals.has(assignmentStage)

  useEffect(() => {
    if (!shouldRedirect) return

    // productKind is what makes TS/Lua drift visible: the Lightroom plugin mirrors this routing rule, so a kind the two disagree on shows up as redirects from one side only
    logGalleryEvent(AnalyticsEvent.CREATIVE_GALLERY_UPLOAD_REDIRECT, { productKind: product?.kind, assignmentStage })
    navigate(Path.CT_UPLOAD.replace(':id', assignmentId), { replace: true })
  }, [assignmentId, assignmentStage, logGalleryEvent, navigate, product?.kind, shouldRedirect])

  return shouldRedirect
}
